import React from 'react';
import DiscountValuePad from './DiscountValuePad';

interface AddDiscountForOrderItemProps {
    discountAmount: number | undefined;
    discountType: string | undefined;
    discountName?: string;
    onClose: () => void;
    onDiscountSubmit: (value: number, discountType: string, discountName?: string) => void;
}

const AddDiscountForOrderItem: React.FC<AddDiscountForOrderItemProps> = ({ onClose, discountAmount, discountType, discountName, onDiscountSubmit }) => {
    return (
        <DiscountValuePad
            title="Add discount"
            subtitle="Selected items"
            initialValue={discountAmount}
            initialType={discountType}
            initialName={discountName}
            onClose={onClose}
            onSubmit={onDiscountSubmit}
        />
    );
};

export default AddDiscountForOrderItem;
